import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import {AllowedPageSizes} from '../../../../../const/constants';
const WMAptmmtsTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    
    const gridKey = "1C45DAE7-ABB0-4EAB-AE40-89778758A9D5";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <Scrolling mode="virtual" />
                <Column dataField="record" caption='Record#' dataType="string"></Column>
                <Column dataField="customerIdentityId" caption='Customer' dataType="string"></Column>
                <Column dataField="customerName" caption='Customer Name' dataType="string"></Column>
                <Column dataField="deliveryPickupPlannedDateTime" caption='Plan Aptmmts Date From' dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="deliveryPickupArrivedDateTime" caption='Plan Aptmmts Date To' dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="warehouseId" caption='Plan WH' dataType="string"></Column>
                <Column dataField="comment" caption='Comment' dataType="string"></Column>
                <Column dataField="location" caption="Location" dataType="string" visible={false}></Column>
                <Column dataField="planResourcesCode" caption="Plan Apntmnt Rsrc" dataType="string" visible={false}></Column>
                <Column dataField="planReference" caption="Plan Reference" dataType="string" visible={false}></Column>
                <Column dataField="planResourcesHours" caption="Plan Apntmnt Rsrc Hrs" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="transferToDispatch" caption="To Dispatch" dataType="string" visible={false}></Column>
                <Column dataField="dispatchOrderNumber" caption="Dispatch #" dataType="string" visible={false}></Column>
                <Column dataField="creationDateTime" caption="Creation Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="creationUserId" caption="Creation User ID" visible={false} />
                <Column dataField="lastUpdateDateTime" caption="Last Update Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lastUpdateUserId" caption="Last Update User ID" visible={false} />
                <Column dataField="department" caption="Department" visible={false} />
                <Column dataField="departmentDescription" caption="Department Description" visible={false} />
                <Column dataField="job" caption="Job" visible={false} />
                <Column dataField="jobDescription" caption="Job Description" visible={false} />
                <Column dataField="fund" caption="Fund" visible={false} />
                <Column dataField="fundDescription" caption="Fund Description" visible={false} />
                <Column dataField="dockYardWH" caption="Dock Yard WH" visible={false} />
                <Column dataField="dockYardWHName" caption="Dock Yard WH Name" visible={false} />
                <Column dataField="plannedReceivedShippedDateTime" caption="Planned Received Shipped Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="stagingStartDate" caption="Staging Start Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="stagingEndDate" caption="Staging End Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="unloadPickByPlanDate" caption="Unload Pick By Plan Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="checkByPlanDate" caption="Check By Plan Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="putAwayByPlanDate" caption="Put Away By Plan Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="fmTruckReference" caption="FM Truck Reference" visible={false} />
                <Column dataField="fmDriverReference" caption="FM Driver Reference" visible={false} />
                <Column dataField="fmTrailerReference" caption="FM Trailer Reference" visible={false} />
                <Column dataField="truckReference" caption="Truck Reference" visible={false} />
                <Column dataField="container" caption="Container" visible={false} />
                <Column dataField="equipmentInterchangeReport" caption="Equipment Interchange Report" visible={false} />
                <Column dataField="deliveryPickupDepartDateTime" caption="Delivery Pickup Depart Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="truckArrivalDateTime" caption="Truck Arrival Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="truckDepartDateTime" caption="Truck Depart Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="transportationYardLeaveDate" caption="Transportation Yard Leave Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="transportDriverID" caption="Transport Driver ID" visible={false} />
                <Column dataField="transportDriverName" caption="Transport Driver Name" visible={false} />
                <Column dataField="transportTrailerID" caption="Transport Trailer ID" visible={false} />
                <Column dataField="transportTruckID" caption="Transport Truck ID" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(WMAptmmtsTab);